(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemResource", ["$resource", learningItemResource]);
    function learningItemResource($resource) {
        return $resource("/api/learningItems/:code/:action", { code: "@code", action: "@action" }, {
            update: {
                method: "PUT"
            },
            publish: {
                method: "POST",
                params: { action: "publish" }
            },
            getIsCodeAvailable: {
                method: "GET",
                params: { action: "isAvailable" }
            },
            getCreateViewModel: {
                method: "GET",
                params: { action: "create" }
            },
            getPublishedItemList: {
                method: "GET",
                isArray: true,
                params: { action: "publishedItems" }
            },
            getAssignedList: {
                method: "GET",
                params: { action: "assignedItems" }
            }
        });
    }
}());
